/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2020 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
import React from "react";
import {useTranslation} from "react-i18next";

export const DeliveryTime: React.FC<{max: number; min: number}> = (props) => {
  const {t} = useTranslation("cart");
  const {max, min} = props;

  if (!max || !min) {
    return null;
  }

  return <div>{daysStringFunction(min, max, t)}</div>;
};

export const daysStringFunction = (
  min: number,
  max: number,
  t: (str: string, opt?: {count: number; daysString: string; ns: string}) => string,
): string => {
  const daysString = max === min ? `${max}` : `${min} - ${max}`;

  return t("ab Versand: ") + t("{{daysString}} Werktag", {count: max, daysString, ns: "checkout"});
};
